module.exports = __webpack_public_path__ + "static/media/HowToAdbop_Mobile_EN_2.ea8f574a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/HowToAdbop_Mobile_EN_2.png
// module id = 583
// module chunks = 0